import { sortBy } from 'lodash';

import React from 'react';

import SessionGraphs, {
  GraphBlueprint,
  GraphOptions,
  GraphSeries,
  GraphPlotband,
  GraphInstanceProps
} from '../index';
import {
  IEpxEndodb,
  IEpxEndodbSettings,
  TimeOfDay
} from '../../../../libs/apps/epxendodb';
import { CHART } from '../../../../config/colors';

const EpxEndodbGraphs: React.FC<GraphInstanceProps> = (props): JSX.Element => {
  const graph: GraphBlueprint<IEpxEndodb, IEpxEndodbSettings> = {
    name: 'Blood Sugar Graph',
    config: {
      chart: {
        type: 'line'
      },
      xAxis: {
        type: 'datetime'
      },
      yAxis: {
        title: {
          text: 'Blood Sugar (mg/dL)'
        }
      },
      responsive: {}
    },
    draw: (sessions, currentOptions, settings) => {
      const options: GraphOptions = {
        series: []
      };
      const series: GraphSeries[] = [
        {
          type: 'line',
          name: 'Breakfast (Pre)',
          connectNulls: true,
          data: []
        },
        {
          type: 'line',
          name: 'Breakfast (Post)',
          connectNulls: true,
          data: []
        },
        {
          type: 'line',
          name: 'Lunch Glucose (Pre)',
          connectNulls: true,
          data: []
        },
        {
          type: 'line',
          name: 'Lunch Glucose (Post)',
          connectNulls: true,
          data: []
        },
        {
          type: 'line',
          name: 'Dinner Glucose (Pre)',
          connectNulls: true,
          data: []
        },
        {
          type: 'line',
          name: 'Dinner Glucose (Post)',
          connectNulls: true,
          data: []
        }
      ];
      sessions = sortBy(sessions, (session) => session.time);
      const TIMES_OF_DAY = [TimeOfDay.M, TimeOfDay.A, TimeOfDay.E];
      for (const [_, session] of sessions.entries()) {
        const time = session.respondedAt || session.time;
        if (!TIMES_OF_DAY.includes(session.timeOfDay)) {
          continue;
        }
        let { bsBefore, bsAfter } = session;
        if (!(0 <= bsBefore && bsBefore <= 1000)) {
          bsBefore = null;
        }
        if (!(0 <= bsAfter && bsAfter <= 1000)) {
          bsAfter = null;
        }
        let s = 0;
        if (session.timeOfDay === TimeOfDay.A) {
          s = 1;
        } else if (session.timeOfDay === TimeOfDay.E) {
          s = 2;
        }
        series[s * 2].data.push([time, bsBefore]);
        series[s * 2 + 1].data.push([time, bsAfter]);
      }
      options.series = series;
      const plotBands: GraphPlotband[] = [];
      if (settings?.thresholds?.red?.fasting?.min >= 0) {
        plotBands.push({
          from: 0,
          to: settings.thresholds?.red.fasting.min,
          color: CHART.PLOT_BAND_DANGER
        });
      }
      if (settings?.thresholds?.red?.fasting?.max >= 0) {
        plotBands.push({
          from: settings.thresholds?.red.fasting.max,
          to: 10000,
          color: CHART.PLOT_BAND_DANGER
        });
      }
      options.yAxis = {
        ...currentOptions.yAxis,
        plotBands: plotBands
      };
      return options;
    }
  };
  return (
    <SessionGraphs<IEpxEndodb>
      url="/data/data_by_range/"
      graphs={[graph]}
      {...props}
    />
  );
};

export default EpxEndodbGraphs;
